import * as React from "react";
import i18n from "i18n";

import { default as firebase } from "common/Firebase";
import {
  TextField,
  Input,
  InputLabel,
  InputAdornment,
  IconButton,
  FormControl,
  Snackbar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  withStyles,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

import { Redirect } from "react-router-dom";
import { observer } from "mobx-react";
import { LoginStore } from "modules/login/LoginStore";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  panel: {
    width: 710,
    margin: "0 auto",
    paddingTop: "55px",
  },
  textField: {
    width: "100%",
  },
  authButton: {
    width: "49%",
    borderRadius: "none",
    height: "36px",
  },
  createAccount: {
    color: "white",
    backgroundColor: "#ABC200",
    "&:hover": {
      backgroundColor: "rgba(171, 194, 0, 0.8)",
    },
    fontSize: "14px",
    fontFamily: "Raleway",
    fontWeight: "600" as any,
    letterSpacing: "1px",
  },
  recoverAccount: {
    color: "rgba(171, 194, 0, 1)",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
    transition: "none",
    padding: 0,
    marginTop: "10px",
    fontSize: "12px",
    fontFamily: "Raleway",
    fontWeight: "600" as any,
  },
  heading: {
    fontSize: "30px",
    color: "#ABC200",
    fontFamily: "Raleway",
  },
  defaultText: {
    fontSize: "16px",
    padding: "8px 0px 25px 0px",
  },
  googleButton: {
    color: "red !important",
  },
});

type IProps = {
  classes: any;
};

@observer
class LoginAuth extends React.Component<IProps> {
  state = {
    open: false,
    openPassRecover: false,
    path: window.location.pathname,
    password: "",
    showPassword: false,
    email: "",
    message: "",
    emailRecovery: "",
    redirect: false,
  };

  componentDidMount() {
    if (LoginStore.isUserAuth) {
      firebase
        .auth()
        .signOut()
        .then(() => {
          LoginStore.userAuth = undefined;
          LoginStore.isUserAuth = false;
        })
        .catch(function (error) {
          console.log("LoginStore.userAuth = error", error);
        });
    }
  }

  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !this.state.showPassword }));
  };

  handleClickLoginAcount = async () => {
    try {
      const user = await firebase
        .auth()
        .signInWithEmailAndPassword(this.state.email, this.state.password);

      if (user) {
        await LoginStore.loadCurrentUser();
        this.setState({ redirect: true });
      }
    } catch (error) {
      this.ShowMessage(error);
    }
  };

  handleKeyDown = async (event) => {
    switch (event.which) {
      case 13:
        try {
          await firebase
            .auth()
            .signInWithEmailAndPassword(this.state.email, this.state.password);
          if (LoginStore.userAuth != undefined) {
            this.setState({ redirect: true });
          }
        } catch (error) {
          this.ShowMessage(error);
        }
    }

    event.preventDefault();
  };

  handleCloseSnack = () => {
    this.setState({ open: false });
  };

  private ShowMessage(errorMessage: any) {
    if (errorMessage != null) {
      console.log("errorMessage.code  ===>>> ", errorMessage.code);
      let message = "";
      if (
        errorMessage.code === "auth/account-exists-with-different-credential"
      ) {
        message = i18n.login.accountExistsDifferent;
      } else if (errorMessage.code === "auth/email-already-in-use") {
        message = i18n.login.emailAlreadyInUse;
      } else if (errorMessage.code === "auth/weak-password") {
        message = i18n.login.passwordLength;
      } else if (errorMessage.code === "auth/wrong-password") {
        message = i18n.login.wrongPassword;
      } else if (errorMessage.code === "new-session") {
        message = i18n.login.newSessionError;
      } else if (errorMessage.code === "invalid-access") {
        message = i18n.login.invalidAccessError;
      } else if (errorMessage.code === "auth/user-disabled") {
        message = i18n.login.userDisabled;
      } else {
        message = i18n.login.loginError;
      }
      this.setState({ open: true, message });
    }
  }

  renderRedirect = () => {
    if (LoginStore.userAuth && LoginStore.isUserAuth) {
      return <Redirect to="/menu/development" />;
    } else return <div />;
  };

  handleClickOpen = () => {
    this.setState({ openPassRecover: true });
  };

  handleClose = () => {
    this.setState({ openPassRecover: false });
  };

  handleRecoverPassword = () => {
    var auth = firebase.auth();
    var emailAddress = this.state.emailRecovery;
    let thisState = this;

    auth
      .sendPasswordResetEmail(emailAddress)
      .then(function () {
        thisState.setState({ message: i18n.login.emailSent, open: true });
      })
      .catch(function (error) {
        thisState.setState({ message: i18n.login.emailNotSent, open: true });
      });
    this.setState({ openPassRecover: false });
  };

  showSnackInLogout() {
    setTimeout(() => {
      if (LoginStore.newSessionError) {
        LoginStore.newSessionError = false;
        this.ShowMessage({ code: "new-session" });
      }

      if (LoginStore.invalidAccessError) {
        LoginStore.invalidAccessError = false;
        this.ShowMessage({ code: "invalid-access" });
      }
    }, 1000);
  }

  render() {
    const { classes } = this.props;
    this.showSnackInLogout();

    return (
      <div className={classes.root}>
        {this.renderRedirect()}
        <form>
          <div className={classes.panel}>
            <div className={classes.heading}>{i18n.login.enterRubk}</div>
            <TextField
              id="txtEmail"
              label="E-mail"
              className={classes.textField}
              onChange={this.handleChange("email")}
              value={this.state.email}
              margin="normal"
              style={{ marginLeft: 0 }}
            />
            <FormControl className={classes.textField} style={{ marginTop: 0 }}>
              <InputLabel htmlFor="adornment-password">
                {i18n.login.password}
              </InputLabel>
              <Input
                id="txtPassword"
                type={this.state.showPassword ? "text" : "password"}
                value={this.state.password}
                onChange={this.handleChange("password")}
                autoComplete="off"
                style={{ marginLeft: 0 }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={this.handleClickShowPassword}
                    >
                      {this.state.showPassword ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>

            <Button
              onClick={this.handleClickOpen}
              className={classes.recoverAccount}
            >
              {i18n.login.forgotPassword}
            </Button>
            <Dialog
              open={this.state.openPassRecover}
              onClose={this.handleClose}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">
                {i18n.login.resetPassword}
              </DialogTitle>
              <DialogContent style={{ width: 600 }}>
                <TextField
                  onChange={this.handleChange("emailRecovery")}
                  autoFocus
                  margin="dense"
                  id="name"
                  label="E-mail"
                  type="email"
                  fullWidth
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="secondary">
                  {i18n.cancel}
                </Button>
                <Button
                  onClick={this.handleRecoverPassword}
                  color="primary"
                  disabled={this.state.emailRecovery.length == 0}
                >
                  {i18n.login.reset}
                </Button>
              </DialogActions>
            </Dialog>
            <div style={{ margin: "0 auto", width: 138, paddingTop: 22 }}>
              <Button
                onClick={() => this.handleClickLoginAcount()}
                style={{ width: "100%" }}
                size="small"
                variant="contained"
                disabled={
                  this.state.email.length == 0 ||
                  this.state.password.length == 0
                }
                className={classes.createAccount}
              >
                {i18n.start}
              </Button>
            </div>
          </div>
        </form>

        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.open}
          onClose={this.handleCloseSnack}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{this.state.message}</span>}
        />
      </div>
    );
  }
}

export default withStyles(styles)(LoginAuth);



// WEBPACK FOOTER //
// ./src/modules/login/components/layouts/LoginAuth.tsx